import { useEffect } from 'react'

import { NotificationType } from 'src/graphql/types/notifications'
import { WebSocketsActionType } from 'src/pages/ApplicantsPage/context/websockets.reducer'
import {
  useWebsockets,
  useWebsocketsDispatch,
} from 'src/pages/ApplicantsPage/context/WebSocketsContext'

import NotificationTab from './NotificationTab'

const Notifications = () => {
  const websocketContext = useWebsockets()
  const websocketDispatch = useWebsocketsDispatch()

  useEffect(() => {
    if (
      websocketContext?.newNotification?.type &&
      [
        NotificationType.SMS,
        NotificationType.VOE_RESPONSE,
        NotificationType.ORDER_UPDATE,
        NotificationType.NOTE,
        NotificationType.EMAIL,
      ].includes(websocketContext?.newNotification?.type as NotificationType)
    ) {
      websocketDispatch({
        type: WebSocketsActionType.CLEAR_NEW_NOTIFICATION,
      })
    }
  }, [websocketContext])

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden">
      <NotificationTab />
    </div>
  )
}

export default Notifications
